const apiUrl = process.env.REACT_APP_API_URL;

export const ToggleAulaIsExamen = async (idAula: string | number, isExamen: boolean) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${idAula}/toggle-is-examen?isExamen=${isExamen}`, {
            method: 'POST'
        });
        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.error('Error toggling aula is examen:', error);
        return null;
    }
};
